import React from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useWarnings } from '../../../status/StatusContext';
import { useHasPermission } from '../../../permission/PermissionUtil';
import { useNavigate } from 'react-router-dom';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function WarningButton() {

    const navigate = useNavigate();

    const openWarnings = () => {
        navigate("/warning/warning");
    };

    const hasViewWarningsPermission = useHasPermission("Warnings:Warning:View");
    const warningsCount = useWarnings();

    if (!hasViewWarningsPermission) {
        return null;
    }

    return (
        <IconButton
            size="large"
            type='button'
            onClick={openWarnings}
            color="inherit"
            style={squareHighlightStyle}
        >
            <Badge badgeContent={warningsCount} color="warning">
                <Tooltip title='Unreviewed Warnings'>
                    <WarningIcon />
                </Tooltip>
            </Badge>
        </IconButton>
    );
}
